import React, { useState } from 'react';
import styles from './styles.module.scss';
import { isoToKrasnoyarskTime } from 'lib/utils';
import { useNavigate } from 'react-router-dom';
import { BuyApartmentFlowPaths } from 'routes';
import useBoundStore from 'store';
import iconRow from 'assets/images/caret-left.svg';
import iconThreeDots from 'assets/images/three-dots.svg';
import BottomSheet from 'components/bottom-sheet';
import BottomSheetItem from 'components/bottom-sheet-item';
import { EFavoritesType } from 'lib/types';
import ChangeTypeFavoriteListForm from './forms/changeTypeListForm';
import ChangeNameFavoriteListForm from './forms/changeNameListForm';
import CopyFavoriteListForm from './forms/copyFavoriteListForm';
import DeleteFavoriteListForm from './forms/deleteFavoriteListForm';

export type IFavoriteListItemProps = {
  id: number;
  isOwner: boolean;
  isClient: boolean;
  title: string;
  author: string;
  createdAt: string;
  updatedAt: string;
  type: EFavoritesType;
  facilitiesCount?: number;
  refetchFavoriteList: () => void;
  clients: string;
};

const FavoriteListItem: React.FC<IFavoriteListItemProps> = (props) => {
  const {
    id,
    title,
    author,
    createdAt,
    updatedAt,
    facilitiesCount,
    type,
    isOwner,
    isClient,
    clients,
    refetchFavoriteList,
  } = props;
  const [showBottomSheetContent, setShowBottomSheetContent] = useState<
    EFavoritesType | 'changeName' | 'copyList' | 'deleteList'
  >();
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);

  const navigate = useNavigate();
  const setLastSelectedFacilityList = useBoundStore((s) => s.setLastSelectedFacilityList);
  const handleRedirectFilterItem = () => {
    if (id) {
      setLastSelectedFacilityList({ favouritesListId: id });
      navigate(BuyApartmentFlowPaths.favoritesFacilityList, { state: { id: id } });
    }
  };

  const handleDismiss = () => {
    setShowBottomSheetContent(undefined);
    setIsBottomSheetOpen(false);
  };

  const authorSplit = author.split(' ');
  const FI = authorSplit[0] + ' ' + authorSplit[1];

  const getViewBottomSheet = () => {
    const isDisplayDeleteTab = !isClient;
    const isDisplayChangeUsersList = isOwner && type === EFavoritesType.Shared;
    const isDisplayChangeNameList = isOwner;
    const isDisplayDoSharedList =
      type !== EFavoritesType.Shared && type !== EFavoritesType.Customer;
    const isDisplayDoCustomerList =
      type !== EFavoritesType.Shared && type !== EFavoritesType.Customer;
    const isDisplayCopyList = !isClient && type !== EFavoritesType.Customer;

    if (showBottomSheetContent) {
      if (showBottomSheetContent === 'changeName') {
        return (
          <ChangeNameFavoriteListForm
            type={type}
            onClose={handleDismiss}
            baseName={title}
            refetchFavoriteList={refetchFavoriteList}
            id={id}
          />
        );
      }
      if (showBottomSheetContent === 'copyList') {
        return (
          <CopyFavoriteListForm
            title={title}
            onClose={handleDismiss}
            id={id}
            type={type}
            refetchList={refetchFavoriteList}
          />
        );
      }
      if (showBottomSheetContent === 'deleteList') {
        return (
          <DeleteFavoriteListForm
            title={title}
            onClose={handleDismiss}
            id={id}
            type={type}
            refetchList={refetchFavoriteList}
            isOwner={isOwner}
          />
        );
      }
      return (
        <ChangeTypeFavoriteListForm
          type={showBottomSheetContent as EFavoritesType}
          onClose={handleDismiss}
          id={id}
          title={title}
          refetchList={refetchFavoriteList}
        />
      );
    }

    return (
      <div>
        {isDisplayDoCustomerList && (
          <BottomSheetItem
            title='Сделать клиентским'
            onClick={() => setShowBottomSheetContent(EFavoritesType.Customer)}
          />
        )}
        {isDisplayDoSharedList && (
          <BottomSheetItem
            title='Сделать совместным'
            onClick={() => setShowBottomSheetContent(EFavoritesType.Shared)}
          />
        )}
        {isDisplayChangeNameList && (
          <BottomSheetItem
            title='Изменить название'
            onClick={() => setShowBottomSheetContent('changeName')}
          />
        )}
        {isDisplayChangeUsersList && (
          <BottomSheetItem
            title='Добавить/Удалить пользователей'
            onClick={() =>
              id &&
              navigate(BuyApartmentFlowPaths.apartmentFavoritesUsers, {
                state: { title, id, type },
              })
            }
          />
        )}

        {isDisplayCopyList && (
          <BottomSheetItem
            title='Копировать список'
            onClick={() => setShowBottomSheetContent('copyList')}
          />
        )}

        {isDisplayDeleteTab && (
          <BottomSheetItem
            className={styles.colorRed}
            title='Удалить'
            onClick={() => setShowBottomSheetContent('deleteList')}
          />
        )}
      </div>
    );
  };

  return (
    <div
      className={styles.container}
      onClick={(e) => {
        handleRedirectFilterItem();
      }}
    >
      <div className={styles.flexContainer}>
        <div className={styles.main}>
          <div className={styles.top}>
            <div className={styles.title}>{title}</div>
            {!isClient && (
              <div className={styles.menu}>
                <img
                  src={iconThreeDots}
                  width={24}
                  height={24}
                  alt='menu'
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsBottomSheetOpen(true);
                  }}
                />
              </div>
            )}
          </div>

          <div className={styles.bottom}>
            <div className={styles.spaceBetween}>
              <div>Кол-во объектов:</div>
              <div>
                <b>{facilitiesCount ?? 0}</b>
              </div>
            </div>

            <div className={styles.spaceBetween}>
              <div> Создатель:</div>
              <div>
                <b>{FI}</b>
              </div>
            </div>

            {(type === EFavoritesType.Customer || type === EFavoritesType.Shared) && (
              <div className={styles.spaceBetween}>
                <div>{type === EFavoritesType.Customer ? 'Клиент: ' : 'Клиенты'}</div>
                <div>
                  <b>{clients}</b>
                </div>
              </div>
            )}

            <div className={styles.spaceBetween}>
              <div>{`Создан: `}</div>
              <div>
                <b>{isoToKrasnoyarskTime(createdAt)}</b>
              </div>
            </div>

            <div className={styles.spaceBetween}>
              <div>{`Обновлен: `}</div>
              <div>
                <b>{isoToKrasnoyarskTime(updatedAt)}</b>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.row}>
          <img src={iconRow} alt={'openList'} />
        </div>
      </div>

      <BottomSheet
        open={isBottomSheetOpen}
        onDismiss={handleDismiss}
        snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight]}
        blocking={false}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ marginBottom: 20 }}>{getViewBottomSheet()}</div>
      </BottomSheet>
    </div>
  );
};

export default FavoriteListItem;
